import routerOptions0 from "C:/BuildAgent/work/546b3c95a3861166/b2c/b2c-nuxt/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}